module.exports = __webpack_public_path__ + "img/submit-activities.a88345b8.svg";